import httpClient from '@/http-client'

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/student-scoring-table-entries/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoringCycle = Options => {
  return httpClient
    .get('/api/student-scoring-entry/scoring/cycle', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoringCycleValue = Options => {
  return httpClient
    .get('/api/student-scoring-entry/scoring/cycle-values', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-scoring-table-entries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScore = data => {
  return httpClient
    .post('/api/student-scoring-table-entries/score-records', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoreComponentAverage = data => {
  return httpClient
    .post('/api/student-scoring-table-entries/components-averages', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  formViewModel,
  getScoringCycle,
  getScoringCycleValue,
  store,
  getScore,
  getScoreComponentAverage
}
